import React, { useEffect, useState } from 'react';
import { ROUTES } from '../../common/constants/routes';
import { SignIn, useAuth } from '@clerk/clerk-react';

const ClerkLogIn = () => {
  const { isSignedIn } = useAuth();
  const [redirectUrl] = useState(() => localStorage.getItem('location'));
  useEffect(() => {
    if (!localStorage.getItem('showPDFConversionMessage') || !isSignedIn) {
      localStorage.setItem('showPDFConversionMessage', 'true');
    }
  }, [isSignedIn]);

  return (
    <React.Fragment>
      <div>
        <SignIn signUpUrl={ROUTES.SIGN_UP} forceRedirectUrl={redirectUrl} />
      </div>
    </React.Fragment>
  );
};

export default ClerkLogIn;
